export const ExpirationDateComponent = {
    template: `
        <oo-input-container>
            <input
                autocomplete="cc-exp"
                id="card-expiration-date"
                name="exp-date"
                ng-model="$ctrl.currentPayment.expirationDate"
                ng-required="true"
                type="tel"
                ui-mask-placeholder-char="space"
                ui-mask-placeholder="MM/YY"
                ui-mask="99/99"
                ui-options="$ctrl.options"
                valid-expiration-date
            />
            <label>Expiration Date</label>
            <div ng-messages="$ctrl.form['exp-date'].$error">
                <div ng-messages-include="generic-messages"></div>
                <div ng-message="inPast, mask">Enter a valid expiration date</div>
            </div>
        </oo-input-container>
    `,
    bindings: {
        currentPayment: '<',
        form: '<'
    },
    controller: class {
        constructor() {
            'ngInject';
            // TODO consolidate common options.
            this.options = { clearOnBlur: false, allowInvalidValue: true, addDefaultPlaceholder: false };
        }
    }
};
